module.exports = __webpack_public_path__ + "media/Chapter3AudioLoop.10d0ffc3.mp3";